export default function useToolTipResize(x, y) {
  let tooltipX = Math.min(x, globalThis.innerWidth - 300)
  const tooltipY = Math.min(y, globalThis.innerHeight - 200)
  const tooltipRight = tooltipX + 200
  const windowWidth = globalThis.innerWidth
  if (tooltipRight > windowWidth) {
    // move the tooltip to the left
    const leftOffset = tooltipRight - windowWidth
    const newTooltipX = Math.max(0, tooltipX - leftOffset)
    if (newTooltipX !== tooltipX) {
      tooltipX = newTooltipX
    }
  }
  return {tooltipX, tooltipY}
}
